import { __decorate } from "tslib";
import { property } from 'lit/decorators.js';
import { css, html, LitElement } from 'lit';
export class List extends LitElement {
    constructor() {
        super(...arguments);
        this.ordered = false;
    }
    render() {
        switch (this.ordered) {
            case true: {
                return html ` <ol>
                    <slot></slot>
                </ol>`;
            }
            default: {
                return html ` <ul>
                    <slot></slot>
                </ul>`;
            }
        }
    }
}
// todo: check if margin/padding var is needed
List.styles = css `
        :host {
            display: block;
        }

        :host(:focus-visible),
        ul:focus-visible,
        ol:focus-visible,
        li:focus-visible {
            outline: 0;
        }

        ul,
        ol {
            color: var(--ep-text-color);
            font-size: var(--ep-text-font-size);
            font-family: var(--ep-text-font-family);
            font-weight: var(--ep-text-font-weight);
            margin-block: 0;
            padding-inline-start: var(--ep-list-padding-inline-start, 20px);
        }

        ol {
            list-style: var(--ep-list-style, decimal);
        }

        ul {
            list-style: var(--ep-list-style, none);
            padding-inline-start: var(--ep-list-ul-padding-inline-start, 20px);
        }

        ::slotted(*) {
            display: none;
        }

        ::slotted(li) {
            display: list-item;
            padding: var(--ep-list-padding, 0);
            margin: var(--ep-list-margin, 0);
        }

        ::slotted(li)::marker {
            color: var(--ep-text-color);
        }
    `;
__decorate([
    property({ type: Boolean })
], List.prototype, "ordered", void 0);
if (!customElements.get('ep-list')) {
    customElements.define('ep-list', List);
}
//# sourceMappingURL=element.js.map